import style from './copyRightFooter.module.css'

const CopyRightFooter = ()=>{
    return ( <div
       className={style.copyRightFooter}
       title={"برمجة وتصميم عبد الكريم الحلبي"}
      >
        <h3 className={style.h4}>  تصميم فريق تقانة المعلومات  </h3>
        <h3 className={style.h4}>  الجامعة الوطنية الخاصة بحماه  </h3>
        <div>
          <span className={style.span}> &#169; </span>
          <div className={style.h3}>المهندس عبدالكريم الحلبي  </div>
          <span className={style.span}> &#174; </span>
        </div>
      </div>) 
}
export default CopyRightFooter;